// extracted by mini-css-extract-plugin
export var cardLayout = "_1v-1";
export var paginationContainer = "_1v-0";